import styled, { css } from 'styled-components';
import useIsMobileView from '../hooks/useIsMobileView';
import { DateInput } from '@prosolve/common-components-ui';

const Container = styled.div`
  @media (max-width: 1400px) {
    & .rbc-btn-group button {
      padding: 0.375rem 0.5rem;
    }
  }
`

const MonthSpanningEvents = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 0 0 12px;

  ${({ $isMobileView }) => $isMobileView && css`
    flex-wrap: wrap;
  `}
`

const MonthSpanningTitle = styled.div`
  font-weight: bold;
  padding-top: 8px;
`

const MonthSpanningEventsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  padding: 10px;
  border: solid 1px #d9dee5;
  border-radius: 8px;
  background: #f8fafc;
  max-height: 130px;
  overflow: hidden auto;
`

const DateWrapper = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  z-index: 10;
`

const EventButton = styled.button`
  max-width: 360px;
  min-width: 0;
  overflow: hidden;
  padding: 5px 9px;
  border: none;
  border-radius: 4px;
  background: ${({ $backgroundColor }) => $backgroundColor || '#3174ad'};
  color: white;
  cursor: pointer;
  font: inherit;
  font-size: 12px;
  line-height: 18px;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const getEventLabel = (event) => {
  const { name, accountName } = event.resource || {};
  return [name, accountName].filter(Boolean).join(' - ');
}

export default function ImplementationCalendarToolbar({
  label,
  date,
  view,
  monthSpanningEvents = [],
  onNavigate,
  onViewChange,
  onSelectEvent,
  getEventColor
}) {
  const isMobileView = useIsMobileView()

  return (
    <Container>
      <div className="rbc-toolbar">
        <span style={{ flex: 1 }}>
          <span className="rbc-btn-group">
            <button type="button" onClick={() => onNavigate('TODAY')}>Today</button>
            <button type="button" onClick={() => onNavigate('PREV')}>Back</button>
            <button type="button" onClick={() => onNavigate('NEXT')}>Next</button>
          </span>
          <span className="rbc-btn-group">
            <button type="button" className={`${!view && 'rbc-active'}`} onClick={() => onViewChange()}>Normal</button>
            <button type="button" className={`${view === 'TALL' && 'rbc-active'}`} onClick={() => onViewChange('TALL')}>Tall</button>
            <button type="button" className={`${view === 'TALLEST' && 'rbc-active'}`} onClick={() => onViewChange('TALLEST')}>Tallest</button>
          </span>
        </span>
        <span className="rbc-toolbar-label" style={{ flex: 1 }}>{label}</span>
        <span style={{ flex: 1, textAlign: 'right' }}>
          <span className="rbc-btn-group">
            <DateWrapper>
              <span>Jump To Date:</span>
              <DateInput value={date} onChange={(d) => onNavigate('DATE', d)} />
            </DateWrapper>
          </span>
        </span>
      </div>

      {monthSpanningEvents.length > 0 &&
        <MonthSpanningEvents $isMobileView={isMobileView}>
          <MonthSpanningTitle>Ongoing</MonthSpanningTitle>
          <MonthSpanningEventsList>
            {monthSpanningEvents.map((event) => {
              const label = getEventLabel(event);
              const backgroundColor = getEventColor?.(event);

              return (
                <EventButton
                  key={event.id}
                  type="button"
                  title={label}
                  $backgroundColor={backgroundColor}
                  onClick={() => onSelectEvent(event)}
                >
                  {label}
                </EventButton>
              );
            })}
          </MonthSpanningEventsList>
        </MonthSpanningEvents>
      }
    </Container>
  );
}
